'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  systemOnline: _react.PropTypes.bool.isRequired
};

var EmailCaptureSuccess = function EmailCaptureSuccess(_ref) {
  var systemOnline = _ref.systemOnline;

  var message = systemOnline ? _I18n2.default.text('conversationsUI.emailCapture.successMessage') : _I18n2.default.text('conversationsUI.emailCapture.maintenanceModeMessage');

  return _react2.default.createElement(
    'div',
    { className: 'email-capture-success-state text-center p-top-3 p-x-11' },
    _react2.default.createElement(
      _Small2.default,
      { use: 'help' },
      message
    )
  );
};

EmailCaptureSuccess.propTypes = propTypes;

exports.default = EmailCaptureSuccess;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/emailCapture/EmailCaptureSuccess.js
// module id = 1114
// module chunks = 2 3